import { PERMISSION_LEVEL } from './permissionLevel';

export const ACCESS_RESOURCE_MAX_PERMISSION = {
  LINK_LEVEL_SETTINGS: PERMISSION_LEVEL.WRITE,
  APP_LEVEL_SETTINGS: PERMISSION_LEVEL.WRITE,
  CHANNEL_LEVEL_SETTINGS: PERMISSION_LEVEL.WRITE,
  TEAM_ACCESS: PERMISSION_LEVEL.WRITE,
  AUDIENCE_BUILDER: PERMISSION_LEVEL.WRITE,
  FRAUD_SETTINGS_AND_DATA: PERMISSION_LEVEL.WRITE,
  SENSITIVE_DATA: PERMISSION_LEVEL.WRITE,
  MOBILE_SEARCH: PERMISSION_LEVEL.WRITE,
  LINK_TEMPLATE_SETTINGS: PERMISSION_LEVEL.WRITE,
  FRAUD_MANAGER: PERMISSION_LEVEL.WRITE,

  REVENUE_DATA: PERMISSION_LEVEL.READ,
  AGGREGATE_DATA: PERMISSION_LEVEL.READ,
  AGENCY_TAGGED_DATA: PERMISSION_LEVEL.READ,
  EXPORT: PERMISSION_LEVEL.READ,
  AD_NETWORKS: PERMISSION_LEVEL.READ,
  LOCATION: PERMISSION_LEVEL.READ,
  FRAUD_REPORTING: PERMISSION_LEVEL.READ,
} as const;
